import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1326fb5b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "agreement bgfff"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bold font25 ac"
}, " Agreement on User Registration and Services ", -1));

const _hoisted_3 = {
  class: "content mt30"
};
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "lh3num",
    innerHTML: _ctx.agreement
  }, null, 8, _hoisted_4)])]);
}